import React, { useRef } from 'react';

import { Card, CardContent, CardHeader, CardTitle, StackedBarChart } from '@mesh.ai/rabbit';
import OverviewSection from 'Deer/components/Overview/OverviewSection';
import useLocalStorageCards from 'Deer/hooks/useLocalStorageCards';
import { setIsCardOpen } from 'Deer/slice/DeerCollapsibleCard.slice';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getUniqueCardKey } from 'utils/helpers/getUniqueCardKey';

export const SkipTeamPerformanceCheckIns = () => {
  const ref = useRef();
  const history = useHistory();

  const dispatch = useDispatch();
  const currentURL = history.location.pathname;

  const localStorageKey = getUniqueCardKey({ url: currentURL, cardId: 'mySkipTeamPerformanceCheckInsOverview' });

  const isCardOpen = useLocalStorageCards({
    localStorageKey,
    card: 'performanceCheckInsOverview',
    section: 'mySkipTeam',
  });

  const handleChange = (newVal: boolean) => {
    dispatch(
      setIsCardOpen({
        card: 'performanceCheckInsOverview',
        section: 'mySkipTeam',
        isCardOpen: newVal,
        localStorageKey,
      })
    );
    return newVal;
  };

  return (
    <OverviewSection
      open={isCardOpen}
      onOpenChange={handleChange}
      title="Performance check-ins"
      showCaption
      subTitleColor="warning"
      subTitle="All your teams are witnessing a consistent drop in check-in frequency, possibly revealing disengagement. Consider discussing this in your 1:1s and setup skip-level 1:1s to understand what is holding your teams back."
    >
      <Card>
        <CardHeader>
          <CardTitle>Check-in frequency</CardTitle>
        </CardHeader>
        <CardContent>
          <div style={{ height: '230px' }}>
            <StackedBarChart
              ref={ref}
              mode="full"
              nodes={[
                {
                  id: '122',
                  name: "Ming Ye's team",
                },
                {
                  id: '123',
                  name: "George Weber's team",
                },
                {
                  id: '124',
                  name: "Helen Mirren's direct reports",
                },
                {
                  id: '121',
                  name: "Jay Chandra's team",
                },
              ]}
              series={[
                {
                  data: [1, 2, 1, 2, 1, 1],
                  id: '121',
                },
                {
                  data: [5, 2.4, 4, 1, 2, 2],
                  id: '122',
                },
                {
                  data: [7, 8, 6, 3, 1, 2],
                  id: '123',
                },
                {
                  data: [4, 8, 9, 1, 1, 2],
                  id: '124',
                },
              ]}
              tooltipTitle="Progress"
              xAxisLabel="Months"
              xAxisValues={['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun']}
              yAxisDomain={[0, 30]}
              yAxisLabel="Check-in counts"
              seriesSelectorTitle="Team members"
            />
          </div>
        </CardContent>
      </Card>
    </OverviewSection>
  );
};
